import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './LanguageSelector.scss';

class LanguageList extends React.Component {
    static propTypes = {
        height: PropTypes.number,
        isOpen: PropTypes.bool.isRequired,
        languages: PropTypes.arrayOf(PropTypes.shape({
            link: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired
    }

    componentDidUpdate() {
        const { isOpen } = this.props;
        const { languagelist } = this;

        if(isOpen) {
            const ul = languagelist.getElementsByTagName('ul')[0];
            languagelist.style.height = `${ul.offsetHeight}px`;
        } else if(languagelist) {
            languagelist.removeAttribute('style');
        }
    }

    render() {
        const { isOpen, languages } = this.props;

        const classNames = classnames('language-list', {
            'open': isOpen,
            'closed': !isOpen,
        });

        return(
            <div
                className={classNames}
                ref={node => this.languagelist = node}
            >
                <ul>
                    {languages.map(function(l, i) {
                        return (
                            <li className={l.active ? 'selected' : undefined} key={i}>
                                <a href={l.link}>
                                    {l.text}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

class LanguageSelector extends React.PureComponent {
    static propTypes = {
        isActive: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        languages: PropTypes.arrayOf(PropTypes.shape({
            link: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
        })).isRequired,
        className: PropTypes.string,
        handleSelectorClick: PropTypes.func
    }

    state = {
        height: 0,
    }

    render() {
        const { languages, isActive, className } = this.props;
        const { height } = this.state;

        if (!languages || languages.length === 0) return null;

        const classNames = classnames('language-link', {
            'open': isActive === 'language',
        });

        const selectedLanguage = languages.find(language => language.isActive) || languages[0];

        return (
            <div className={classnames('language-wrapper', {
                [`${className}`]: className
            })}>
                <button
                    className={classNames}
                    onClick={this.props.handleSelectorClick}
                >
                    {selectedLanguage.text}
                </button>
                <LanguageList
                    height={height}
                    languages={languages}
                    isOpen={isActive === 'language'}
                />
            </div>
        );
    }
}

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/LanguageSelector.jsx